// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"02477d9c","290":"d27b1e05","511":"4e5f6b2d","771":"4dc63d66"}[chunkId] + ".chunk.js";
};